/*
String.format for javascript.
Usage: 'My name is {0} and I work as a {1}'.format('Anders', 'Developer');
*/
if (!String.prototype.format) {
    String.prototype.format = function () {
        var args = arguments;
        return this.replace(/{(\d+)}/g, function (match, number) {
            return typeof args[number] != 'undefined'
                ? args[number]
                : match
                ;
        });
    };
}